module.exports = __webpack_public_path__ + "img/DSC_1137.f9d2301d.jpg";